'use client'

// Third-party Imports
import classnames from 'classnames'

// Type Imports

import type { ChildrenType, SystemMode } from '@core/types'

// Hook Imports
import useLayoutInit from '@core/hooks/useLayoutInit'
import { useSettings } from '@core/hooks/useSettings'

// Util Imports
import { blankLayoutClasses } from './utils/layoutClasses'

type Props = ChildrenType & {
  systemMode: SystemMode
}

const BlankLayout = (props: Props) => {
  // Props
  const { children, systemMode } = props

  // Hooks
  const { settings } = useSettings()

  useLayoutInit(systemMode)

  return (
    <div className={classnames(blankLayoutClasses.root, 'is-full bs-full')} data-skin={settings.skin}>
      {children}
    </div>
  )
}

export default BlankLayout
